import { ReactNode } from "react";
import { createPortal } from "react-dom";
import styles from "./style.module.scss";
import { useIsExportPortal } from "@utils/exportPortal";

type LoadingScreenProps = {
  isLoading: boolean;
  /** Contenido opcional bajo el spinner, para procesos largos (progreso, paso actual). */
  children?: ReactNode;
};

const LoadingScreen = (props: LoadingScreenProps) => {
  const { isLoading, children } = props;
  const isExportPortal = useIsExportPortal();

  /**
   * El overlay se monta en `document.body`, asi que dentro de un portal de
   * exportacion se escaparia del contenedor oculto y taparia la app real.
   */
  if (!isLoading || isExportPortal) {
    return null;
  }

  return createPortal(
    <div data-testid="loading-screen" className={styles.overlay}>
      <div className={styles.content}>
        <div className={styles.lds_roller}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {children && (
          <div className={styles.message}>
            {children}
          </div>
        )}
      </div>
    </div>
    , document.body);
}

export default LoadingScreen;
